import { Subscriptions } from '@mui/icons-material';
import { Box, Button, Card, CardContent, Chip, Divider, FormControl, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import React, { useEffect, useRef, useState } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import authService from '../Auth/AuthService';
import axios from 'axios';


const AddSucriptionForm = ({ loginId, coupon, onSuccess }) => {
    const [subscription, setSubscription] = useState({
        couponCode: coupon?.coupon?.code || '',
        paymentId: '',
        referralId: coupon?.id || '',
        startDate: new Date(),
        endDate: new Date(),
        applicablePlans: [],
        isActive: true,
    });
    const [subscriptionPlans, setSubscriptionPlans] = useState([]);
    const hasFetched = useRef(false);
    const [selectedPlanDetails, setSelectedPlanDetails] = useState([]);

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;

        axios
            .get(authService.pathUrl("GET", "/subscription/plans"))
            .then((res) => {
                setSubscriptionPlans(res?.data || []);
                setSubPlans(res?.data || []);
            })
            .catch((error) => {
                console.error("Failed to fetch subscription plans:", error.message);
            })
    }, []);


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setSubscription((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));

        if (name === 'applicablePlans') {
            const plan = subscriptionPlans.find((p) => p.id === value);
            setSelectedPlanDetails(plan || null);

            // const formatDate = (date) => {
            //     return date.toISOString().split("T")[0];
            // };

            const endDate = new Date();
            endDate.setDate(endDate.getDate() + plan.durationInDays);

            setSubscription((prev) => ({
                ...prev,
                endDate: (endDate),
            }));
        }
    };

    const setSubPlans = (suPlans) => {
        const plan = suPlans.find((p) => p.name === coupon?.coupon?.planName[0]);
        setSelectedPlanDetails(plan || null);
        subscription.applicablePlans = plan.id;
        // const formatDate = (date) => {
        //     return date.toISOString().split("T")[0];
        // };

        const endDate = new Date();
        endDate.setDate(endDate.getDate() + plan.durationInDays);

        setSubscription((prev) => ({
            ...prev,
            endDate: (endDate),
        }));
    };

    const handleDateChange = (field, date) => {
        setSubscription((prev) => ({
            ...prev,
            [field]: date
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (subscription.applicablePlans < 1) {
            return;
        }

        const payload = {
            ...subscription,
            loginId: loginId.id,
            paidby: loginId.paidby,
            planId: subscription.applicablePlans
        };
        try {
            const url = authService.pathUrl("POST", '/subscriptions/admin');
            await authService.postAuth(url, payload);
            if (onSuccess) onSuccess();
            // window.location.reload();
        } catch (error) {
            console.log('Submitted subscription:', error);
        }

    }
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box sx={{ mx: 'auto', p: 0 }}>
                <Card elevation={6} sx={{ borderRadius: 4, p: 3 }}>
                    <CardContent>
                        <Typography variant="h5" fontWeight="bold" gutterBottom>
                            <Subscriptions sx={{ mr: 1, verticalAlign: 'middle', color: '#1b1914' }} />
                            Add Subscription
                        </Typography>
                        <Divider sx={{ mb: 5 }} />
                        <Box component="form" onSubmit={handleSubmit} mt={3}>
                            <Grid container spacing={3} sx={{ display: 'flex', flexDirection: 'column', flexWrap: 'nowrap' }}>

                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Coupon Code"
                                        name="couponCode"
                                        fullWidth
                                        // required
                                        value={subscription.couponCode}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Payment Id/ UTR Id"
                                        name="paymentId"
                                        fullWidth
                                        required
                                        value={subscription.paymentId}
                                        onChange={handleChange}
                                    />
                                </Grid>


                                <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                    <DesktopDatePicker
                                        label="Start Date"
                                        value={subscription.startDate}
                                        onChange={(date) => handleDateChange('startDate', date)}
                                        renderInput={(params) => <TextField {...params} fullWidth />}
                                    />

                                    <DesktopDatePicker
                                        label="End Date"
                                        value={subscription.endDate}
                                        onChange={(date) => handleDateChange('endDate', date)}
                                        renderInput={(params) => <TextField {...params} fullWidth />}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth>
                                        <InputLabel id="applicable-plans-label">
                                            Applicable Plans
                                        </InputLabel>
                                        <Select
                                            labelId="applicable-plans-label"
                                            name="applicablePlans"
                                            value={subscription.applicablePlans || ''}
                                            onChange={handleChange}
                                            required={Boolean(selectedPlanDetails === null)}
                                            input={<OutlinedInput label="Applicable Plans" />}
                                            renderValue={(selected) => {
                                                const plan = subscriptionPlans.find((p) => p.id === selected);
                                                return (
                                                    <Chip key={selected} label={plan?.name || selected} color="info" />
                                                );
                                            }}
                                        >
                                            {subscriptionPlans?.map((plan) => (
                                                <MenuItem key={plan.id} value={plan.id}>
                                                    <ListItemText primary={plan.name} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        size="large"
                                        fullWidth
                                        sx={{
                                            borderRadius: '20px',
                                            backgroundColor: '#1b1914',
                                            '&:hover': { backgroundColor: '#503e02ff' }
                                        }}
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                            </Grid>

                            <Grid>
                                {selectedPlanDetails && (
                                    <Box sx={{ mt: 3, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                                        <Typography variant="h6" gutterBottom>
                                            Plan Details
                                        </Typography>
                                        <Typography><strong>Name:</strong> {selectedPlanDetails.name}</Typography>
                                        <Typography><strong>Price:</strong> ₹{selectedPlanDetails.price}</Typography>
                                        <Typography><strong>Duration:</strong> {selectedPlanDetails.durationInDays} days</Typography>
                                        <Typography><strong>Description:</strong> {selectedPlanDetails.description}</Typography>
                                    </Box>
                                )}
                            </Grid>
                        </Box>

                    </CardContent>
                </Card>
            </Box>
        </LocalizationProvider>
    )
}
export default AddSucriptionForm;